import React from 'react'

function ApprovedCashLoanLayer() {
  return (
    <div>ApprovedCashLoanLayer</div>
  )
}

export default ApprovedCashLoanLayer